import DocumentTemplateList from "./pages/ListPage.vue";
import DocumentTemplateDetail from "./pages/FormPage.vue";
import DocumentTemplateIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/document_template",
    component: DocumentTemplateIndex,
    redirect: "/document_template/list",
    name: "document_template",
    children: [
      {
        path: "list",
        component: DocumentTemplateList,
        name: "document_template.list",
      },
      {
        path: "create",
        component: DocumentTemplateDetail,
        name: "document_template.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: DocumentTemplateDetail,
        name: "document_template.edit",
        props: { create: false },
      },
    ],
  },
];
